import ApiClient from '../ApiClient';

const GroupService = {
    async getAllGroups(queryParams) {
        const resp = await ApiClient.get('/Whatsapp/group-list', {
            params: queryParams,
        });
        return resp;
    },

    async getGroups() {
        const resp = await ApiClient.get(`/Whatsapp/groups`);
        return resp;
    },

    async createGroup(payload) {
        const resp = await ApiClient.post('/Whatsapp/create-group', payload);
        return resp;
    },

    async updateGroup(payload) {
        const resp = await ApiClient.put('/Whatsapp/update-group', payload);
        return resp;
    },

    async deleteGroup(id) {
        const resp = await ApiClient.delete(`/Whatsapp/delete-group/${id}`);
        return resp;
    },

    async insertBulkLead(payload) {
        const resp = await ApiClient.post('/lead/bulk-lead-insert', payload);
        return resp;
    },

    async addLead(lead) {
        const resp = await ApiClient.post(`/lead/add-lead-request`, lead);
        return resp;
      },

};

export default GroupService;


